import { Divider, Flex, Icon, Box, Text } from '@cad-arc';
import { LoadingIndicator } from '../../../../common/components/loading-indicator';
import { observer } from 'mobx-react-lite';
import { useEsriMapStore } from '../../../hooks/use-esri-map-store';
import { CloseMapLedgerAndClearSelectedEntityButton } from '../close-map-ledger-and-clear-selected-entity-button';

export const LocationOverview = observer(function LocationOverview({
    isLoading,
}: {
    isLoading?: boolean;
}): React.ReactElement {
    const mapStore = useEsriMapStore();
    const geoPointLocation = mapStore.locationSearchSelectedGeoPointLocation;

    const { placeName, entityLinks, streetAddress, fullAddressKey } = geoPointLocation || {};

    const locationPinTitle =
        placeName || entityLinks?.[0]?.placeName || streetAddress || fullAddressKey;

    return (
        <Box data-testid="MAP_LOCATION_OVERVIEW_SECTION">
            <Flex alignItems="center" justifyContent="space-between" padding="12px 18px">
                <Flex gap={2}>
                    <Flex alignItems="center">
                        <Icon
                            aria-label="Location pin icon"
                            icon="Location"
                            color="brand.default"
                            size="md"
                            data-testid="MAP_LOCATION_PIN_ICON"
                        />
                    </Flex>
                    {isLoading ? (
                        <LoadingIndicator />
                    ) : (
                        <Text fontWeight="bold" style={{ wordBreak: 'break-word' }}>
                            {locationPinTitle}
                        </Text>
                    )}
                </Flex>
                <CloseMapLedgerAndClearSelectedEntityButton />
            </Flex>
            <Divider />
        </Box>
    );
});
